import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PublishProductFromTemplateDTO, ProductDTO, ConflictResolutionOption } from '../../../../base/models/models.swagger.generated';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-publishing-summary',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TagModule],
  templateUrl: './publishing-summary.component.html',
  styleUrls: ['./publishing-summary.component.scss']
})
export class PublishingSummaryComponent {
  @Input() publishRequests: PublishProductFromTemplateDTO[] = [];
  @Input() publishedProducts: ProductDTO[] = [];
  @Output() publish = new EventEmitter<void>();

  public isPublishing: boolean = false;
  public publishComplete: boolean = false;

  public onPublish() {
    this.isPublishing = true;
    this.publish.emit();
    setTimeout(() => {
      this.isPublishing = false;
      this.publishComplete = true;
    }, 1500);
  }

  public getPublishStatus(request: PublishProductFromTemplateDTO): string {
    return request.resolutionOption === ConflictResolutionOption.CreateNew ? 'Ready to Publish' : 'Update Existing';
  }

  public getStatusClass(request: PublishProductFromTemplateDTO): 'success' | 'info' {
    return request.resolutionOption === ConflictResolutionOption.CreateNew ? 'success' : 'info';
  }
}
